import { ErrorBoundary, Shadow, Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { useBatchTicketTotalSummary } from '../../../../hooks';
import { flatListProps } from '../../../../utils';
import { ItemSeparator } from '../../../ItemSeparator';
import { TotalSummaryItem } from '../TotalSummaryItem';

interface TotalSummaryProps {}

export const TotalSummary: React.FC<TotalSummaryProps> = () => {
  const { totalSummaryData } = useBatchTicketTotalSummary();

  return (
    <VStack space={Spacing['inline.xxxs']} py={{ base: Spacing['inline.xxxs'], sm: 0 }}>
      <Box pt={Spacing['inline.xxxs']}>
        <Text variant="bold" color="neutral.dark" fontSize={Typography['fontsize.md']}>
          Clientes adicionados
        </Text>
      </Box>
      {totalSummaryData?.length === 0 && (
        <Box py={{ sm: Spacing['inline.md'] }}>
          <ErrorBoundary
            errorIconOrIllustration="NotEmptyIllustration"
            errorTitle="Nenhum item encontrado."
            errorMessage="Não existe nenhum item nesta seção."
          />
        </Box>
      )}
      <Shadow level={3}>
        <FlatList
          {...flatListProps}
          data={totalSummaryData}
          keyExtractor={(item) => item?.basketCustomerOrderId}
          maxH="800px"
          flex={1}
          ItemSeparatorComponent={ItemSeparator}
          renderItem={({ item }) => <TotalSummaryItem item={item} />}
        />
      </Shadow>
    </VStack>
  );
};
